/**
 * Test IDs for QA automation.
 *
 * Originally generated by the data-testid codemod, now hand-maintained.
 * Per-row ids are suffixed at the call site with a stable row key
 * (`storageFacility.identifier ?? good._id`) so each commodity row — including
 * multiple tanks holding the same commodity — is individually selectable.
 */
export const testIds = {
  receiverGoodsListGoodCheckbox: "receiver-goods-list-good-checkbox",
  receiverGoodsListCommodityQuantitySelect: "receiver-goods-list-commodity-quantity-select",
  receiverGoodsListCommodityQuantityMenuItem: "receiver-goods-list-commodity-quantity-menu-item",
  receiverGoodsListCommodityQuantityInput: "receiver-goods-list-commodity-quantity-input",
  receiverGoodsListShipperAutocomplete: "receiver-goods-list-shipper-autocomplete",
  receiverGoodsListSupplierAutocomplete: "receiver-goods-list-supplier-autocomplete",
  receiverGoodsListPinCodeInput: "receiver-goods-list-pin-code-input",
  receiverGoodsListTrueSourceBtn: "receiver-goods-list-true-source-btn",
} as const;
